VIV.behaviours.examples = (function () {

    const attach = function (context) {
        const examples = context.querySelector('#examples');
        if (!examples) {
            return;
        }
        const examplesDataJSON = examples.getAttribute('data-examples');
        if (!examplesDataJSON) {
            return;
        }
        const examplesData = JSON.parse(examplesDataJSON.trim());
        const currentExample = window.location.href.split('/')[window.location.href.split('/').length - 1];
        const currentIndex = examplesData.indexOf(currentExample);

        if (currentIndex === -1) {
            return;
        }

        const nextExample = examplesData[currentIndex + 1];
        const prevExample = examplesData[currentIndex - 1];

        window.addEventListener('keyup', function (event) {
            if (event.code === 'ArrowRight' && nextExample) {
                window.location.href = window.location.href.replace(currentExample, nextExample);
            }
            if (event.code === 'ArrowLeft' && prevExample) {
                window.location.href = window.location.href.replace(currentExample, prevExample);
            }
        });
    }

    return {
        attach: attach
    }
})();
